module.exports = __webpack_public_path__ + "img/bannerTitle.a0269c10.png";